import { useEffect, useState } from "react";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import MobileLeftSection from "../../Components/MobileLeftSection";
import { useSelector } from "react-redux";
import Loading from "../../Components/Loading";

export default function MobileSupport() {
  const [SideOpener, setSideOpner] = useState(false);

  const { loading, error, batchDet } = useSelector(
    (s) => s.get_contact_batchReducer
  );

  const OpenSideMenu = (e) => {
    setSideOpner(!SideOpener);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {loading ? <Loading /> : ""}
      <div className="Mobile_View_css">
        <div
          onClick={OpenSideMenu}
          className={SideOpener ? "menu-overlay active" : "menu-overlay"}
          id="menuOverlay"
        ></div>
        <MobileLeftSection SideOpener={SideOpener} Page="Support" />
        <div className="main-content">
          <MobileHeaderSection Page="Support" OpenSideMenu={OpenSideMenu} />
          <div className="Mobile_Support">
            <div className="container">
              <div className="headerTeam">
                <h1>Support Team</h1>
                <p>
                  We're here to help! Connect with our dedicated support
                  professionals for any assistance you need.
                </p>
              </div>

              <div className="content">
                <div className="intro">
                  <h2>Meet Our Team</h2>
                  <p>
                    Our experienced support team is committed to providing you
                    with exceptional service and quick solutions. Whether you
                    need technical assistance, have questions about our
                    services, or require training support, we're here to help.
                  </p>
                </div>

                <div className="team-grid">
                  <div className="team-card">
                    <div className="avatar">
                      <img
                        src="/assets/image/Neha_Sagar.png"
                        alt="Neha Sagar"
                      />
                    </div>
                    <div className="name">Neha Sagar</div>
                    <div className="role Coordinator_top">
                      <p> Coordinator</p>
                    </div>
                    <div className="contact-info">
                      <div className="contact-item">
                        <div className="contact-icon">📧</div>
                        <div className="contact-text">
                          <a href="mailto:info@testifyi.com">
                            info@testifyi.com
                          </a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">📱</div>
                        <div className="contact-text">
                          <a href="tel:+919310123737">+91 9310123737</a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">🎯</div>
                        <div className="contact-text">
                          Project coordination & client support
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="team-card">
                    <div className="avatar">
                      <img
                        src="/assets/image/Vivek_Sharma.png"
                        alt="Profile"
                        className="profile-img"
                      />
                    </div>
                    <div className="name">Vivek Sharma</div>
                    <div className="role Coordinator_top">
                      <p className="EducationCoordinator">Manager </p>
                    </div>
                    <div className="contact-info">
                      <div className="contact-item">
                        <div className="contact-icon">📧</div>
                        <div className="contact-text">
                          <a href="mailto:info@testifyi.com">
                            info@testifyi.com
                          </a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">📱</div>
                        <div className="contact-text">
                          <a href="tel:+917982476900">+91 7982476900</a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">🎯</div>
                        <div className="contact-text">
                          Team management & strategic support
                        </div>
                      </div>
                    </div>
                  </div>

                  {batchDet ? (
                    <div className="team-card">
                      <div className="avatar">
                        {batchDet?.Faculty?.First_Name == "Disha" ? (
                          <img
                            src="/assets/image/Disha.png"
                            alt="Disha"
                            className="profile-img"
                          />
                        ) : batchDet?.Faculty?.First_Name == "Avinash" ? (
                          <img
                            src="/assets/image/Abinash.png"
                            alt="Avinash"
                            className="profile-img"
                          />
                        ) : (
                          <img
                            src="/assets/image/user.svg"
                            alt="Profile"
                            className="profile-img"
                          />
                        )}
                      </div>
                      <div className="name">
                        {batchDet?.Faculty?.First_Name
                          ? batchDet?.Faculty?.First_Name +
                            " " +
                            batchDet?.Faculty?.Last_Name
                          : "Trainer"}
                      </div>
                      <div className="role Coordinator_top">
                        <p className="EducationTrainer"> Trainer</p>
                      </div>
                      <div className="contact-info">
                        <div className="contact-item">
                          <div className="contact-icon">📧</div>
                          <div className="contact-text">
                            <a href="mailto:trainer@testifyi.com">
                              trainer@testifyi.com
                            </a>
                          </div>
                        </div>
                        <div className="contact-item">
                          <div className="contact-icon">📱</div>
                          <div className="contact-text">
                            <a href="tel:+919310123737">
                              +91 {batchDet?.Faculty?.PhoneNo}
                            </a>
                          </div>
                        </div>
                        <div className="contact-item">
                          <div className="contact-icon">🎯</div>
                          <div className="contact-text">
                            Training & educational support
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="footer">
                <h3>Need Help?</h3>
                <p>
                  Don't hesitate to reach out to any of our team members. We're
                  committed to providing you with the best support experience
                  possible.
                </p>

                <div className="support-hours">
                  <strong>Support Hours:</strong>
                  <br />
                  Mon - Sat : 10:00 AM - 5:00 PM
                  <br />
                  {/* Saturday: 10:00 AM - 4:00 PM
                  <br /> */}
                  Sunday: Closed
                </div>
              </div>
            </div>
          </div>
          <MobileBottomMenu Page="Supports" />
        </div>
      </div>
    </>
  );
}
